<template>
  <div id="func-16">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
    />
    <SolicitacaoHistoricoGeral
      :funcionalidade="funcionalidade"
      :rota-detalhe="rotaDetalhe"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoHistoricoGeral from '@/components/TemplateSolicitacao/SolicitacaoHistoricoGeral'

export default {
  name: 'Func49Historico',
  components: {
    SolicitacaoHistoricoGeral,
    FuncionalidadeHeader
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('SetupApp', ['configuracaoAcesso']),
    tituloNavegacao () {
      return this.configuracaoAcesso.meusProtocolos.parametros.textos.tituloHistorico
    },
    rotaDetalhe () {
      return `/49/detalhe`
    }
  },
  methods: {
    async init () {
    }
  },
  mounted () {
    this.init()
  }
}
</script>
